/* -disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

function Tag({ text, highlight, ...props }) {
  return (
    <li
      className={`AdminTableTagListTag${
        highlight ? ' AdminTableTagListTag--highlight' : ''
      }`}
      {...props}
    >
      {text}
    </li>
  );
}

Tag.propTypes = {
  text: PropTypes.string,
  highlight: PropTypes.bool,
};

export default Tag;
